export default "__VITE_ASSET__Be4aSj4x__"